import * as core from "./core.js";
export * from "./core.js";
import Aurora from "./vanta.aurora.js";
import Birds from "./vanta.birds.js";
import Cells from "./vanta.cells.js";
import Clouds from "./vanta.clouds.js";
import Clouds2 from "./vanta.clouds2.js";
import Dots from "./vanta.dots.js";
import Flow from "./vanta.flow.js";
import Fog from "./vanta.fog.js";
import Globe from "./vanta.globe.js";
import Grid from "./vanta.grid.js";
import Halo from "./vanta.halo.js";
import Mesh from "./vanta.mesh.js";
import Net from "./vanta.net.js";
import Rings from "./vanta.rings.js";
import Ripple from "./vanta.ripple.js";
import Starfield from "./vanta.starfield.js";
import Topology from "./vanta.topology.js";
import Trunk from "./vanta.trunk.js";
import Waves from "./vanta.waves.js";
core.register("aurora", Aurora);
core.register("birds", Birds);
core.register("cells", Cells);
core.register("clouds", Clouds);
core.register("clouds2", Clouds2);
core.register("dots", Dots);
core.register("flow", Flow);
core.register("fog", Fog);
core.register("globe", Globe);
core.register("grid", Grid);
core.register("halo", Halo);
core.register("mesh", Mesh);
core.register("net", Net);
core.register("rings", Rings);
core.register("ripple", Ripple);
core.register("starfield", Starfield);
core.register("topology", Topology);
core.register("trunk", Trunk);
core.register("waves", Waves);
const api = { ...core };
api.AURORA = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "aurora",
  });
api.BIRDS = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "birds",
  });
api.CELLS = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "cells",
  });
api.CLOUDS = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "clouds",
  });
api.CLOUDS2 = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "clouds2",
  });
api.DOTS = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "dots",
  });
api.FLOW = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "flow",
  });
api.FOG = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "fog",
  });
api.GLOBE = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "globe",
  });
api.GRID = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "grid",
  });
api.HALO = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "halo",
  });
api.MESH = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "mesh",
  });
api.NET = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "net",
  });
api.RINGS = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "rings",
  });
api.RIPPLE = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "ripple",
  });
api.STARFIELD = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "starfield",
  });
api.TOPOLOGY = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "topology",
  });
api.TRUNK = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "trunk",
  });
api.WAVES = (options) =>
  core.create({
    ...(typeof options === "string" || options?.nodeType === 1
      ? { target: options }
      : options),
    effect: "waves",
  });
export default Object.freeze(api);
